import styled from 'styled-components';

export const HeaderButton = styled.button`
  position: relative;
  display: flex;
  width: fit-content;
  min-width: 50px;
  height: 40px;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 5px;
  border: 1px solid transparent;
  background: ${({ theme }) => theme.colors.neutral.lightest};
  color: ${({ theme }) => theme.colors.primary.default};
  transition: all 0.2s;

  &:hover {
    border: 1px solid
      ${({ theme, color }) =>
        color ? theme.colors[color].default : theme.colors.primary.default};
  }

  span {
    color: ${({ theme, color }) =>
      color ? theme.colors[color].default : theme.colors.primary.default};
    text-align: center;
    font-family: Poppins;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px;
  }

  svg {
    flex-shrink: 0;
    font-size: 18px;
    fill: ${({ theme, color }) =>
      color ? theme.colors[color].default : theme.colors.primary.default};
  }
`;
